import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

const HOLD_ADMIN_TOOLS = [
  {
    path: "/AdminHoldBulkOps",
    title: "Hold 코인 일괄 정리",
    description:
      "진입중·익절후 대기·재시작 상태의 Hold 활성 코인을 SetpageHold와 동일한 방식으로 일괄 정리합니다. (더블 계정·심볼 필터 지원)",
    badge: "Bulk ops",
    cardTone: "ops",
  },
  {
    path: "/AdminCoinsDataBulk",
    title: "홀드버전 DB 수정",
    description:
      "coins_data_hold 테이블을 조건 검색 후 선택 행의 설정값을 일괄 수정합니다.",
    badge: "DB bulk",
    cardTone: "start",
  },
];

export default function AdminHoldPage() {
  const [cookies] = useCookies(["uuid"]);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 없습니다. 관리자 로그인 페이지로 이동합니다.");
      window.location.href = "/AdminLogin";
      return;
    }

    fetch(`/SetPage/admin_user?uuid=${cookies.uuid}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("서버 응답 실패");
        }
        return response.json();
      })
      .then((data) => {
        const user = data[0];
        if (!user) {
          throw new Error("관리자 정보 없음");
        }
        const readOnly = user.admin_possible === "1" || user.admin_possible === 1;
        if (readOnly) {
          alert("읽기 전용 관리자는 Hold 관리 페이지를 사용할 수 없습니다.");
          window.location.href = "/Adminpage";
          return;
        }
        setAuthChecked(true);
      })
      .catch(() => {
        alert("관리자 인증에 실패했습니다.");
        window.location.href = "/AdminLogin";
      });
  }, [cookies.uuid]);

  const handleLogout = () => {
    const uuid = cookies.uuid;
    if (!uuid) {
      window.location.href = "/AdminLogin";
      return;
    }
    fetch("/super_logout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: uuid }),
    }).finally(() => {
      window.location.href = "/AdminLogin";
    });
  };

  if (!authChecked) {
    return (
      <main className="admin-dashboard admin-hold-hub">
        <section className="admin-dashboard__panel">
          <p className="admin-dashboard__eyebrow">인증 확인 중...</p>
        </section>
      </main>
    );
  }

  return (
    <main className="admin-dashboard admin-hold-hub">
      <div className="admin-dashboard__glare" aria-hidden="true" />
      <section className="admin-dashboard__panel">
        <header className="admin-dashboard__hero">
          <div>
            <p className="admin-dashboard__eyebrow">Bitgenstone · Hold admin</p>
            <h1 className="admin-dashboard__title">Hold 관리</h1>
            <p className="admin-dashboard__subtitle">
              Hold 전용 운영 도구입니다. 활성 코인 일괄 정리와 DB 일괄 수정을 사용할 수 있습니다.
            </p>
          </div>
          <div className="admin-dashboard__hero-actions">
            <button
              type="button"
              className="admin-dashboard__btn admin-dashboard__btn--ghost"
              onClick={() => {
                window.location.href = "/Adminpage";
              }}
            >
              Super admin
            </button>
            <button
              type="button"
              className="admin-dashboard__btn admin-dashboard__btn--danger"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </header>

        <div className="admin-hold-hub__grid">
          {HOLD_ADMIN_TOOLS.map((tool) => (
            <Link
              key={tool.path}
              to={tool.path}
              className={`admin-hold-hub__card admin-hold-hub__card--${tool.cardTone}`}
            >
              <span className="admin-hold-hub__badge">{tool.badge}</span>
              <h2 className="admin-hold-hub__card-title">{tool.title}</h2>
              <p className="admin-hold-hub__card-desc">{tool.description}</p>
              <span className="admin-hold-hub__card-cta">페이지 열기 →</span>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
